export default __webpack_public_path__ + "static/media/bamazon.17a9fe02.jpg";